import Swiper from "swiper/bundle";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";

export default class FiltersCarousel {
  constructor(el) {
    this.carousel = el;
    this.swiper = null;
  }

  init() {
    this.initSwiper(this.carousel);
  }

  initSwiper(carousel) {
    this.swiper = new Swiper(carousel, {
      direction: "horizontal",
      loop: false,
      spaceBetween: 0,
      slidesPerView: "auto",
      navigation: {
        nextEl: carousel.nextElementSibling.querySelector(
          ".carousel-button-next",
        ),
        prevEl: carousel.nextElementSibling.querySelector(
          ".carousel-button-prev",
        ),
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    });
  }
}
